import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import { ToastContainer, toast, Slide } from 'react-toastify';
import { analyticsTrack } from '../../analyticsUtils';
import EmployerInterviewCard from './EmployerInterviewCard';
import './EmployerInterviews.scss';
var CARDS_PER_BLOCK = 10;
var emptyInterviewsCopy = {
  upcoming: 'When you schedule an interview with a candidate, you will find the interview details here.',
  pending: 'When you are waiting for candidates to confirm interviews, you will find the invitation details here.',
  past: 'When you have held an interview with a candidate, you will find the details of that interview here.',
  reschedule: 'When there is a reschedule request by a candidate, you will find the details of that interview here.'
};
var renderTab = function renderTab(active, onClick, copy, count) {
  return /*#__PURE__*/React.createElement("a", {
    role: "button",
    tabIndex: "0",
    onClick: onClick,
    className: "body-text-2 medium-weight tab-active-".concat(active, " ").concat(copy, "-tab")
  }, copy, ' ', "(", count, ")");
};
var allowedTypes = ['upcoming', 'pending', 'reschedule', 'past'];
var EmployerInterviews = /*#__PURE__*/function (_React$Component) {
  function EmployerInterviews(props) {
    var _this;
    _classCallCheck(this, EmployerInterviews);
    _this = _callSuper(this, EmployerInterviews, [props]);
    var defaultTypeProp = allowedTypes.includes(_this.props.type) ? _this.props.type : 'upcoming';
    _this.state = {
      type: defaultTypeProp,
      numCardsDisplayed: {
        upcoming: CARDS_PER_BLOCK,
        past: CARDS_PER_BLOCK,
        pending: CARDS_PER_BLOCK,
        reschedule: CARDS_PER_BLOCK
      }
    };
    _this.clickTab = _this.clickTab.bind(_this);
    return _this;
  }
  _inherits(EmployerInterviews, _React$Component);
  return _createClass(EmployerInterviews, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      analyticsTrack('Viewed My Interviews Page', {});
      var _this$props = this.props,
        toastMessage = _this$props.toastMessage,
        rescheduleLink = _this$props.rescheduleLink;
      if (toastMessage) {
        toast.success(/*#__PURE__*/React.createElement("span", null, toastMessage, "\xA0Reschedule", ' ', /*#__PURE__*/React.createElement("a", {
          className: "reschedule-interview-link",
          href: rescheduleLink
        }, "here.")));
      }
    }
  }, {
    key: "getInterviewsToRender",
    value: function getInterviewsToRender() {
      var _this$state = this.state,
        type = _this$state.type,
        numCardsDisplayed = _this$state.numCardsDisplayed;
      var interviews = this.props.interviews;
      return interviews[type].slice(0, numCardsDisplayed[type]);
    }
  }, {
    key: "canShowMore",
    value: function canShowMore() {
      var _this$state2 = this.state,
        type = _this$state2.type,
        numCardsDisplayed = _this$state2.numCardsDisplayed;
      var interviewsByType = this.props.interviews[type];
      return numCardsDisplayed[type] < interviewsByType.length;
    }
  }, {
    key: "clickTab",
    value: function clickTab(type) {
      this.setState({
        type: type
      });
    }
  }, {
    key: "clickShowMore",
    value: function clickShowMore() {
      var _this$state3 = this.state,
        type = _this$state3.type,
        numCardsDisplayed = _this$state3.numCardsDisplayed;
      var oldNumOfType = numCardsDisplayed[type];
      var newNumCardsDisplayed = update(numCardsDisplayed, _defineProperty({}, type, {
        $set: oldNumOfType + CARDS_PER_BLOCK
      }));
      this.setState({
        numCardsDisplayed: newNumCardsDisplayed
      });
    }
  }, {
    key: "renderEmptyInterviews",
    value: function renderEmptyInterviews() {
      var type = this.state.type;
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 normal-weight"
      }, emptyInterviewsCopy[type]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var type = this.state.type;
      var interviews = this.props.interviews;
      var interviewsToRender = this.getInterviewsToRender();
      return /*#__PURE__*/React.createElement("div", {
        className: "employer-interviews-container style-guide"
      }, /*#__PURE__*/React.createElement(ToastContainer, {
        position: "bottom-center",
        transition: Slide,
        hideProgressBar: true,
        autoClose: 8000,
        closeOnClick: true,
        draggable: false,
        pauseOnHover: true,
        pauseOnFocusLoss: true,
        className: "cancelled-interview-toast-container",
        toastClassName: "cancelled-interview-toast",
        bodyClassName: "cancelled-interview-toast-body"
      }), /*#__PURE__*/React.createElement("div", {
        className: "dashboard-header-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dashboard-header container"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-3"
      }, "My Interviews"), /*#__PURE__*/React.createElement("div", {
        className: "interview-tabs d-flex flex-column gap-4 flex-md-row"
      }, renderTab(type === 'upcoming', function () {
        return _this2.clickTab('upcoming');
      }, 'Upcoming', interviews.upcoming.length), renderTab(type === 'pending', function () {
        return _this2.clickTab('pending');
      }, 'Pending', interviews.pending.length), renderTab(type === 'reschedule', function () {
        return _this2.clickTab('reschedule');
      }, 'Reschedule Request', interviews.reschedule.length), renderTab(type === 'past', function () {
        return _this2.clickTab('past');
      }, 'Past', interviews.past.length)))), /*#__PURE__*/React.createElement("div", {
        className: "employer-interviews-body container"
      }, interviewsToRender.length > 0 ? interviewsToRender.map(function (interview) {
        return /*#__PURE__*/React.createElement(EmployerInterviewCard, {
          key: interview.id,
          interview: interview
        });
      }) : this.renderEmptyInterviews()), this.canShowMore() && /*#__PURE__*/React.createElement("div", {
        className: "show-more-interviews-container width-790-centered"
      }, /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: "0",
        className: "show-more-interviews btn btn-secondary",
        onClick: function onClick() {
          return _this2.clickShowMore();
        }
      }, "Show More")));
    }
  }]);
}(React.Component);
EmployerInterviews.propTypes = {
  interviews: PropTypes.shape({
    upcoming: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    pending: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    past: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  }).isRequired,
  type: PropTypes.oneOf(allowedTypes),
  toastMessage: PropTypes.string,
  rescheduleLink: PropTypes.string
};
EmployerInterviews.defaultProps = {
  type: 'upcoming',
  toastMessage: null,
  rescheduleLink: '#'
};
export default EmployerInterviews;